<script setup>
// Video & GIF Tools 分类枢纽 /free-tools/video/（nuxt#19 P2）。
import "@/assets/styles/free-tools.css";
definePageMeta({ layout: "free-tools" });
const GROUP = ["video", "gif"];
useHead({
  title: "Free Video & GIF Tools — Convert, Compress, Trim | SharkFoto",
  meta: [{ name: "description", content: "Free video and GIF tools: convert, compress, trim, crop, resize, mute, merge and make GIFs — processed securely and never stored. No sign-up, no watermark." }],
  link: [{ rel: "canonical", href: "https://sharkfoto.com/free-tools/video/" }],
  script: [{ type: "application/ld+json", innerHTML: JSON.stringify({ "@context": "https://schema.org", "@type": "CollectionPage", name: "Free Video & GIF Tools", url: "https://sharkfoto.com/free-tools/video/" }) }],
});
</script>

<template>
  <FreeToolsHub :group="GROUP" :crumb="[['Home', 'https://sharkfoto.com/'], ['Free Tools', 'https://sharkfoto.com/free-tools/'], ['Video &amp; GIF', '']]" title-prefix="Free video &amp; GIF tools" intro="Convert, compress, trim, crop, resize and merge video, plus make and optimise GIFs — light edits run in your browser, heavy transcodes on our servers." />
</template>
